import React from 'react'
import TeamPlaceholder from '@/assets/images/placeholder/team.png'
import { BLUR_DATA_URL_BASE64, S3_PREFIX } from '@/shared/constants'
import playerImg from '@/assets/images/placeholder/player.svg'
import CustomLink from '../customLink'
import { getSlugUrl } from '@/shared/utils'
import MyImage from '@/shared/components/myImage'

function CurrentSeries({ data, cardtitle, urlStat, titleData, titleFirst, dataProperty }: any) {
  return (
    <>
      {data && (
        <section className=" bg-headersActive rounded-xl">
          <div className={`font-semiboldp-0 rounded-xl`}>
            <>
              <p className="py-3 px-3 md:px-4 border-b border-tabBorder text-sm md:text-base font-normal text-textDselected">
                {cardtitle}
              </p>

              <div className="px-3 md:px-4 pb-3 md;pb-4">
                {data?.slice(0, 3).map((series: any, index: number) => {
                  return (
                    <>
                      {index === 0 ? (
                        <div className="py-4 md:py-5 flex justify-between items-center border-b border-tabBorder">
                          <div className="flex items-center gap-3 md:gap-4  ">
                            <div
                              className={`overflow-hidden rounded-full md:w-[60px] md:h-[60px] w-12 h-12`}
                            >
                              <MyImage
                                src={
                                  series?.oPlayer?.oImg?.sUrl
                                    ? `${S3_PREFIX}${series?.oPlayer?.oImg?.sUrl}`
                                    : playerImg
                                }
                                alt="user"
                                blurDataURL={BLUR_DATA_URL_BASE64}
                                placeholder="blur"
                                width={60}
                                height={60}
                                className="border border-[#20272D] rounded-full"
                              />
                            </div>
                            <div className="mb-1">
                              <CustomLink
                                href={getSlugUrl('/' + series?.oPlayer?.oSeo?.sSlug)}
                                className="overflow-hidden whitespace-nowrap flex text-sm md:text-base text-textOffWhite font-medium"
                              >
                                {series?.oPlayer?.sFullName}
                              </CustomLink>
                              <div className="mb-0 gap-1.5 flex items-center text-xs md:text-sm text-textDselected font-normal">
                                <MyImage
                                  src={
                                    series?.oTeam?.oImg?.sUrl
                                      ? `${S3_PREFIX}${series?.oTeam?.oImg?.sUrl}`
                                      : TeamPlaceholder
                                  }
                                  className="overflow-hidden rounded-full w-3.4 h-3.5 md:h-4 md:w-4"
                                  width={16}
                                  height={16}
                                  alt={data?.oPlayer?.oImg?.sText}
                                  sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
                                />
                                <div
                                  className={`mb-0 text-xs md:text-sm text-textDselected font-normal`}
                                >
                                  {series?.oTeam?.sTitle}
                                </div>
                              </div>
                            </div>
                          </div>
                          {cardtitle === 'Highest Wickets' ? (
                            series?.nWickets ? (
                              <div
                                className={`overflow-hidden whitespace-nowrap text-lg md:text-[28px] font-bold text-textOffWhite text-right`}
                              >
                                {series?.nWickets}
                                <div className="text-xs md:text-base text-textOffWhite font-normal">
                                  Wickets
                                </div>
                              </div>
                            ) : (
                              ''
                            )
                          ) : (
                            <div
                              className={`overflow-hidden whitespace-nowrap text-lg md:text-[28px] font-bold text-textOffWhite text-right`}
                            >
                              {titleData !== null || undefined ? titleData : series?.nRuns}
                              <div className="text-xs md:text-base text-textOffWhite font-normal">
                                {titleFirst != null || undefined ? titleFirst : 'Runs'}
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="flex gap-3 justify-between border-b border-tabBorder py-4 md:py-5">
                          <div className="overflow-hidden whitespace-nowrap flex items-center">
                            <CustomLink
                              href={getSlugUrl('/' + series?.oPlayer?.oSeo?.sSlug)}
                              className="overflow-hidden whitespace-nowrap flex gap-3 items-center text-textOffWhite text-sm md:text-base font-medium"
                            >
                              <div className={`mb-0`}> {index + 1}.</div>
                              <div className="flex items-center gap-1.5 md:gap-3">
                                <MyImage
                                  src={
                                    series?.oPlayer?.oImg?.sUrl
                                      ? `${S3_PREFIX}${series?.oPlayer?.oImg?.sUrl}`
                                      : playerImg
                                  }
                                  alt="user"
                                  blurDataURL={BLUR_DATA_URL_BASE64}
                                  placeholder="blur"
                                  width={24}
                                  height={24}
                                  className="border w-5 h-5 md:w-6 md:h-6 border-[#20272D] rounded-full"
                                />
                                {series?.oPlayer?.sFullName}
                              </div>
                            </CustomLink>
                            <div
                              className={`mb-0 text-sm md:text-base text-textDselected font-medium`}
                            >
                              {' '}
                              &nbsp;&nbsp;({series?.oTeam?.sAbbr})
                            </div>
                          </div>
                          <div
                            className={`overflow-hidden whitespace-nowrap text-sm md:text-base font-medium text-textOffWhite`}
                          >
                            {titleFirst != null || undefined
                              ? series?.[dataProperty]
                              : series?.nRuns}{' '}
                            {titleFirst != null || undefined ? titleFirst : 'Runs'}
                          </div>
                        </div>
                      )}
                    </>
                  )
                })}
                {urlStat ? (
                  <div className={`cs-item flex flex-row-reverse pt-6`}>
                    <CustomLink
                      href={urlStat}
                      className="overflow-hidden whitespace-nowrap w-full text-center p-2 rounded-lg bg-buttonBg dark:!text-textOffWhite !text-white text-xs font-medium "
                    >
                      <span>View Full Table</span>
                    </CustomLink>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </>
          </div>
        </section>
      )}
    </>
  )
}

export default CurrentSeries
